import { render, staticRenderFns } from "./ClientChangesTimeline.vue?vue&type=template&id=3f72db6b&scoped=true&lang=pug"
import script from "./ClientChangesTimeline.vue?vue&type=script&lang=js"
export * from "./ClientChangesTimeline.vue?vue&type=script&lang=js"
import style0 from "./ClientChangesTimeline.vue?vue&type=style&index=0&id=3f72db6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f72db6b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
